export default __webpack_public_path__ + "static/media/lato-blackitalic.25585134.eot";